import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PromotionRewardType } from './Enums'
/**
* Class OrderPromotionDto
*  
*/
export class OrderPromotionDto extends ActiveModel {

  /**
  * promotionId
  *   */
  @ActiveField()
  promotionId?: null | number


/**
  * publicTitle
  * 
  */
  @ActiveField('')
  publicTitle: string = ''


  /**
  * rewardTypeSnapshot
  * словарь значений публикуется под именем `Domain.Entities.Promotions.PromotionRewardType`  *   * Тип награды акции (дискриминатор TPH).  *   * - `PercentDiscount` Процентная скидка  *   * Процентная скидка на выбранную область корзины.  * - `FixedAmountDiscount` Фиксированная скидка  *   * Фиксированная сумма скидки.  * - `FixedPrice` Фиксированная цена  *   * Товар по фиксированной цене за единицу.  * - `FreeShipping` Бесплатная доставка  *   * Скидка на стоимость доставки.  * - `NPlusM` N+M  *   * Акция N+M: часть единиц бесплатно при покупке набора.  * - `Bundle` Комплект  *   * Комплект товаров по фиксированной цене.  * - `Gift` Подарок  *   * Бесплатные единицы подарочного товара в корзине.  * - `PercentCashback` Процентный кэшбэк  *   * Процентный кэшбэк бонусами (не снижает цену).  * - `FixedAmountCashback` Фиксированный кэшбэк  *   * Фиксированный кэшбэк бонусами (не снижает цену).  * - `PointsMultiplier` Множитель баллов  *   * Множитель базового начисления баллов лояльности.  *   */
  @ActiveField(PromotionRewardType.PERCENTDISCOUNT)
  rewardTypeSnapshot: PromotionRewardType = PromotionRewardType.PERCENTDISCOUNT


  /**
  * discountAmount
  *   */
  @ActiveField()
  discountAmount?: number


  /**
  * cashbackAmount
  *   */
  @ActiveField()
  cashbackAmount?: number


  /**
  * pointsMultiplier
  *   */
  @ActiveField()
  pointsMultiplier?: number


/**
  * termsSnapshot
  * 
  */
  @ActiveField()
  termsSnapshot?: null | string
}
